import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, _, u ) => {
	return {
		tableContainer: {
			height   : "474px",
			width    : "100%",
			margin   : "0 !important",
			padding  : "0 !important",
			fontSize : "2rem"
		},
		tableText: {
			[u.smallerThan ( "md" )]: {
				fontSize: "1rem"
			},
			fontSize : "1.3rem",
			color    : theme.other.colors.text.primary
		},
		menuIconButton: {
			color: theme.other.colors.text.primary
		},
		overlay: {
			background: theme.other.colors.background.secondary,

			"& .MuiCircularProgress-root": {
				color: theme.other.colors.text.secondary
			}
		},
		footerContainer: {
			"& .MuiToolbar-root": {
				color: theme.other.colors.text.primary,

				"& .MuiButtonBase-root.Mui-disabled": {
					color: theme.other.colors.text.secondary

				}
			}
		}
	};
} );